export const enabledPlugins = [
	'align',
	'charCounter',
	'codeBeautifier',
	'codeView',
	'colors',
	'draggable',
	'embedly',
	'emoticons',
	'fontFamily',
	'fontSize',
	'fullscreen',
	'lineBreaker',
	'lineHeight',
	'link',
	'lists',
	'paragraphFormat',
	'paragraphStyle',
	'quote',
	'table',
	'url',
	'wordPaste'
];
